import React from "react";

const StepIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="w-full px-4 py-6">
      <div className="px-12 mx-auto">
        <div className="flex items-center mx-10">
          {steps.map((stepName, i) => {
            const stepNum = i + 1;
            const isDone = stepNum < currentStep;
            const isActive = stepNum === currentStep;

            return (
              <React.Fragment key={stepName}>
                {/* Step item */}
                <div
                  className={`flex items-center gap-3 flex-shrink-0 ${isDone && onStepClick ? "cursor-pointer" : "cursor-default"}`}
                  onClick={() => isDone && onStepClick && onStepClick(stepNum)}
                >
                  {/* Circle */}
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-all duration-300 ${
                      isDone
                        ? "border-[#069855] bg-[#069855]/10 text-[#069855]"
                        : isActive
                        ? "border-[#069855] text-[#069855]"
                        : "border-[#575B72] text-[#575B72]"
                    }`}
                  >
                    {isDone ? (
                      <svg className="w-3.5 h-3.5" viewBox="0 0 14 14" fill="none">
                        <path
                          d="M2 7l3.5 3.5L12 3"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      stepNum
                    )}
                  </div>

                  {/* Label */}
                  <span
                    className={`text-base transition-colors duration-200 ${
                      isDone
                        ? "text-[#069855]"
                        : isActive
                        ? "dark:text-white text-textSecondary font-medium"
                        : "text-[#575B72]"
                    }`}
                  >
                    {stepName}
                  </span>
                </div>

                {/* Animated line connector between steps */}
                {i < steps.length - 1 && (
                  <div className="flex-1 mx-4 h-px bg-gray-700/40 dark:bg-white/[0.08] relative overflow-hidden">
                    <div
                      className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#069855] to-[#069855]/40 transition-all duration-500"
                      style={{ width: stepNum < currentStep ? "100%" : "0%" }}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Progress bar — corrected formula so Step 3 = 100% */}
        <div className="w-full bg-gray-700/30 dark:bg-white/[0.06] h-0.5 rounded-full mt-6">
          <div
            className="bg-gradient-to-r from-pink-500 to-blue-500 h-0.5 rounded-full transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
